import socketio from 'socket.io-client';
const socketIOClient = socketio(process.env.REACT_APP_API_SOCKET_IO, { transports: ['polling', 'websocket'] })

export default socketIOClient